module.exports = __webpack_public_path__ + "img/logo.f02e2fea.png";